// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.1
//   protoc               v3.21.12
// source: kessoku_wire.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "kessoku_wire";

export enum ConnType {
  DEFAULT_CONN = 0,
  UNRECOGNIZED = -1,
}

export enum NatType {
  UNKNOWN_NAT = 0,
  ASYMMETRIC = 1,
  SYMMETRIC = 2,
  UNRECOGNIZED = -1,
}

export enum ImageQuality {
  NotSet = 0,
  Low = 2,
  Balanced = 3,
  Best = 4,
  UNRECOGNIZED = -1,
}

export enum ClipboardFormat {
  Text = 0,
  Rtf = 1,
  Html = 2,
  ImageRgba = 21,
  ImagePng = 22,
  ImageSvg = 23,
  Special = 31,
  UNRECOGNIZED = -1,
}

export enum KeyboardMode {
  Legacy = 0,
  Map = 1,
  Translate = 2,
  Auto = 3,
  UNRECOGNIZED = -1,
}

export enum ControlKey {
  Unknown = 0,
  Alt = 1,
  Backspace = 2,
  CapsLock = 3,
  Control = 4,
  Delete = 5,
  DownArrow = 6,
  End = 7,
  Escape = 8,
  F1 = 9,
  F10 = 10,
  F11 = 11,
  F12 = 12,
  F2 = 13,
  F3 = 14,
  F4 = 15,
  F5 = 16,
  F6 = 17,
  F7 = 18,
  F8 = 19,
  F9 = 20,
  Home = 21,
  LeftArrow = 22,
  Meta = 23,
  Option = 24,
  PageDown = 25,
  PageUp = 26,
  Return = 27,
  RightArrow = 28,
  Shift = 29,
  Space = 30,
  Tab = 31,
  UpArrow = 32,
  Insert = 58,
  CtrlAltDel = 100,
  UNRECOGNIZED = -1,
}

export interface PunchHoleRequest {
  id: string;
  natType: NatType;
  licenceKey: string;
  connType: ConnType;
  token: string;
  version: string;
  udpPort: number;
  forceRelay: boolean;
  upnpPort: number;
  socketAddrV6: Uint8Array;
}

export interface PunchHoleResponse {
  socketAddr: Uint8Array;
  pk: Uint8Array;
  failure: PunchHoleResponse_Failure;
  relayServer: string;
  otherFailure: string;
}

export enum PunchHoleResponse_Failure {
  ID_NOT_EXIST = 0,
  OFFLINE = 2,
  LICENSE_MISMATCH = 3,
  LICENSE_OVERUSE = 4,
  UNRECOGNIZED = -1,
}

export interface RequestRelay {
  id: string;
  uuid: string;
  socketAddr: Uint8Array;
  relayServer: string;
  secure: boolean;
  licenceKey: string;
  connType: ConnType;
  token: string;
}

export interface RelayResponse {
  socketAddr: Uint8Array;
  uuid: string;
  relayServer: string;
  id?: string | undefined;
  pk?: Uint8Array | undefined;
  refuseReason: string;
  version: string;
}

export interface RendezvousMessage {
  punchHoleRequest?: PunchHoleRequest | undefined;
  punchHoleResponse?: PunchHoleResponse | undefined;
  requestRelay?: RequestRelay | undefined;
  relayResponse?: RelayResponse | undefined;
}

export interface EncodedVideoFrame {
  data: Uint8Array;
  key: boolean;
  pts: bigint;
}

export interface EncodedVideoFrames {
  frames: EncodedVideoFrame[];
}

export interface VideoFrame {
  vp9s?: EncodedVideoFrames | undefined;
  display: number;
}

export interface IdPk {
  id: string;
  pk: Uint8Array;
}

export interface DisplayInfo {
  x: number;
  y: number;
  width: number;
  height: number;
  name: string;
  online: boolean;
}

export interface Features {
  privacyMode: boolean;
  terminal: boolean;
}

export interface PeerInfo {
  username: string;
  hostname: string;
  platform: string;
  displays: DisplayInfo[];
  currentDisplay: number;
  sasEnabled: boolean;
  version: string;
  features: Features | undefined;
}

export interface CodecAbility {
  vp8: boolean;
  vp9: boolean;
  av1: boolean;
  h264: boolean;
  h265: boolean;
}

export interface SupportedDecoding {
  abilityVp9: number;
  abilityH264: number;
  abilityH265: number;
  prefer: SupportedDecoding_PreferCodec;
  abilityVp8: number;
  abilityAv1: number;
  i444: CodecAbility | undefined;
}

export enum SupportedDecoding_PreferCodec {
  Auto = 0,
  VP9 = 1,
  H264 = 2,
  H265 = 3,
  VP8 = 4,
  AV1 = 5,
  UNRECOGNIZED = -1,
}

export interface OptionMessage {
  imageQuality: ImageQuality;
  showRemoteCursor: OptionMessage_BoolOption;
  disableAudio: OptionMessage_BoolOption;
  disableClipboard: OptionMessage_BoolOption;
  supportedDecoding: SupportedDecoding | undefined;
  disableKeyboard: OptionMessage_BoolOption;
}

export enum OptionMessage_BoolOption {
  NotSet = 0,
  No = 1,
  Yes = 2,
  UNRECOGNIZED = -1,
}

export interface LoginRequest {
  username: string;
  password: Uint8Array;
  myId: string;
  myName: string;
  option: OptionMessage | undefined;
  videoAckRequired: boolean;
  version: string;
  myPlatform: string;
}

export interface LoginResponse {
  error?: string | undefined;
  peerInfo?: PeerInfo | undefined;
}

export interface Hash {
  salt: string;
  challenge: string;
}

/**
 * These channels are deliberately disabled by the browser client, but native
 * peers can still send their initial service frames before the negotiated
 * options take effect.  Decode and bound them so they can be ignored without
 * treating valid RustDesk traffic as an unknown application message.
 */
export interface AudioFrame {
  data: Uint8Array;
}

export interface Clipboard {
  compress: boolean;
  content: Uint8Array;
  width: number;
  height: number;
  format: ClipboardFormat;
  specialName: string;
}

export interface CliprdrMonitorReady {
}

export interface CliprdrFormat {
  id: number;
  format: string;
}

export interface CliprdrServerFormatList {
  formats: CliprdrFormat[];
}

export interface CliprdrServerFormatListResponse {
  msgFlags: number;
}

export interface CliprdrServerFormatDataRequest {
  requestedFormatId: number;
}

export interface CliprdrServerFormatDataResponse {
  msgFlags: number;
  formatData: Uint8Array;
}

export interface CliprdrFileContentsRequest {
  streamId: number;
  listIndex: number;
  dwFlags: number;
  nPositionLow: number;
  nPositionHigh: number;
  cbRequested: number;
  haveClipDataId: boolean;
  clipDataId: number;
}

export interface CliprdrFileContentsResponse {
  msgFlags: number;
  streamId: number;
  requestedData: Uint8Array;
}

export interface CliprdrTryEmpty {
}

export interface CliprdrFile {
  name: string;
  size: bigint;
}

export interface CliprdrFiles {
  files: CliprdrFile[];
}

export interface Cliprdr {
  ready?: CliprdrMonitorReady | undefined;
  formatList?: CliprdrServerFormatList | undefined;
  formatListResponse?: CliprdrServerFormatListResponse | undefined;
  formatDataRequest?: CliprdrServerFormatDataRequest | undefined;
  formatDataResponse?: CliprdrServerFormatDataResponse | undefined;
  fileContentsRequest?: CliprdrFileContentsRequest | undefined;
  fileContentsResponse?: CliprdrFileContentsResponse | undefined;
  tryEmpty?: CliprdrTryEmpty | undefined;
  files?: CliprdrFiles | undefined;
}

export interface PublicKey {
  asymmetricValue: Uint8Array;
  symmetricValue: Uint8Array;
}

export interface SignedId {
  id: Uint8Array;
}

export interface TestDelay {
  time: bigint;
  fromClient: boolean;
  lastDelay: number;
  targetBitrate: number;
}

/**
 * Cursor messages are decoded so a keyboard-enabled session can safely
 * consume the peer's cursor-service traffic. The MVP does not render a
 * synthetic remote cursor, but it validates these bounded messages before
 * ignoring them.
 */
export interface CursorData {
  id: bigint;
  hotx: number;
  hoty: number;
  width: number;
  height: number;
  colors: Uint8Array;
}

export interface CursorPosition {
  x: number;
  y: number;
}

export interface MouseEvent {
  mask: number;
  x: number;
  y: number;
  modifiers: ControlKey[];
}

export interface KeyEvent {
  down: boolean;
  press: boolean;
  controlKey?: ControlKey | undefined;
  chr?: number | undefined;
  unicode?: number | undefined;
  seq?: string | undefined;
  win2winHotkey?: number | undefined;
  modifiers: ControlKey[];
  mode: KeyboardMode;
}

export interface SwitchDisplay {
  display: number;
  x: number;
  y: number;
  width: number;
  height: number;
  cursorEmbedded: boolean;
}

export interface ChatMessage {
  text: string;
}

export interface Misc {
  chatMessage?: ChatMessage | undefined;
  switchDisplay?: SwitchDisplay | undefined;
  option?: OptionMessage | undefined;
  closeReason?: string | undefined;
  refreshVideo?: boolean | undefined;
  videoReceived?: boolean | undefined;
}

export interface Message {
  signedId?: SignedId | undefined;
  publicKey?: PublicKey | undefined;
  testDelay?: TestDelay | undefined;
  videoFrame?: VideoFrame | undefined;
  loginRequest?: LoginRequest | undefined;
  loginResponse?: LoginResponse | undefined;
  hash?: Hash | undefined;
  mouseEvent?: MouseEvent | undefined;
  audioFrame?: AudioFrame | undefined;
  cursorData?: CursorData | undefined;
  cursorPosition?: CursorPosition | undefined;
  cursorId?: bigint | undefined;
  keyEvent?: KeyEvent | undefined;
  clipboard?: Clipboard | undefined;
  misc?: Misc | undefined;
  cliprdr?: Cliprdr | undefined;
  peerInfo?: PeerInfo | undefined;
}

function createBasePunchHoleRequest(): PunchHoleRequest {
  return {
    id: "",
    natType: 0,
    licenceKey: "",
    connType: 0,
    token: "",
    version: "",
    udpPort: 0,
    forceRelay: false,
    upnpPort: 0,
    socketAddrV6: new Uint8Array(0),
  };
}

export const PunchHoleRequest: MessageFns<PunchHoleRequest> = {
  encode(message: PunchHoleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.natType !== 0) {
      writer.uint32(16).int32(message.natType);
    }
    if (message.licenceKey !== "") {
      writer.uint32(26).string(message.licenceKey);
    }
    if (message.connType !== 0) {
      writer.uint32(32).int32(message.connType);
    }
    if (message.token !== "") {
      writer.uint32(42).string(message.token);
    }
    if (message.version !== "") {
      writer.uint32(50).string(message.version);
    }
    if (message.udpPort !== 0) {
      writer.uint32(56).int32(message.udpPort);
    }
    if (message.forceRelay !== false) {
      writer.uint32(64).bool(message.forceRelay);
    }
    if (message.upnpPort !== 0) {
      writer.uint32(72).int32(message.upnpPort);
    }
    if (message.socketAddrV6.length !== 0) {
      writer.uint32(82).bytes(message.socketAddrV6);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PunchHoleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePunchHoleRequest();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.natType = reader.int32() as any;
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.licenceKey = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.connType = reader.int32() as any;
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.token = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.version = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.udpPort = reader.int32();
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.forceRelay = reader.bool();
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.upnpPort = reader.int32();
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.socketAddrV6 = reader.bytes();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<PunchHoleRequest>): PunchHoleRequest {
    return PunchHoleRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PunchHoleRequest>): PunchHoleRequest {
    const message = createBasePunchHoleRequest();
    message.id = object.id ?? "";
    message.natType = object.natType ?? 0;
    message.licenceKey = object.licenceKey ?? "";
    message.connType = object.connType ?? 0;
    message.token = object.token ?? "";
    message.version = object.version ?? "";
    message.udpPort = object.udpPort ?? 0;
    message.forceRelay = object.forceRelay ?? false;
    message.upnpPort = object.upnpPort ?? 0;
    message.socketAddrV6 = object.socketAddrV6 ?? new Uint8Array(0);
    return message;
  },
};

function createBasePunchHoleResponse(): PunchHoleResponse {
  return { socketAddr: new Uint8Array(0), pk: new Uint8Array(0), failure: 0, relayServer: "", otherFailure: "" };
}

export const PunchHoleResponse: MessageFns<PunchHoleResponse> = {
  encode(message: PunchHoleResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.socketAddr.length !== 0) {
      writer.uint32(10).bytes(message.socketAddr);
    }
    if (message.pk.length !== 0) {
      writer.uint32(18).bytes(message.pk);
    }
    if (message.failure !== 0) {
      writer.uint32(24).int32(message.failure);
    }
    if (message.relayServer !== "") {
      writer.uint32(34).string(message.relayServer);
    }
    if (message.otherFailure !== "") {
      writer.uint32(58).string(message.otherFailure);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PunchHoleResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePunchHoleResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.socketAddr = reader.bytes();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.pk = reader.bytes();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.failure = reader.int32() as any;
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.relayServer = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.otherFailure = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<PunchHoleResponse>): PunchHoleResponse {
    return PunchHoleResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PunchHoleResponse>): PunchHoleResponse {
    const message = createBasePunchHoleResponse();
    message.socketAddr = object.socketAddr ?? new Uint8Array(0);
    message.pk = object.pk ?? new Uint8Array(0);
    message.failure = object.failure ?? 0;
    message.relayServer = object.relayServer ?? "";
    message.otherFailure = object.otherFailure ?? "";
    return message;
  },
};

function createBaseRequestRelay(): RequestRelay {
  return {
    id: "",
    uuid: "",
    socketAddr: new Uint8Array(0),
    relayServer: "",
    secure: false,
    licenceKey: "",
    connType: 0,
    token: "",
  };
}

export const RequestRelay: MessageFns<RequestRelay> = {
  encode(message: RequestRelay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    if (message.socketAddr.length !== 0) {
      writer.uint32(26).bytes(message.socketAddr);
    }
    if (message.relayServer !== "") {
      writer.uint32(34).string(message.relayServer);
    }
    if (message.secure !== false) {
      writer.uint32(40).bool(message.secure);
    }
    if (message.licenceKey !== "") {
      writer.uint32(50).string(message.licenceKey);
    }
    if (message.connType !== 0) {
      writer.uint32(56).int32(message.connType);
    }
    if (message.token !== "") {
      writer.uint32(66).string(message.token);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequestRelay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseRequestRelay();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.uuid = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.socketAddr = reader.bytes();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.relayServer = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.secure = reader.bool();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.licenceKey = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.connType = reader.int32() as any;
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.token = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<RequestRelay>): RequestRelay {
    return RequestRelay.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RequestRelay>): RequestRelay {
    const message = createBaseRequestRelay();
    message.id = object.id ?? "";
    message.uuid = object.uuid ?? "";
    message.socketAddr = object.socketAddr ?? new Uint8Array(0);
    message.relayServer = object.relayServer ?? "";
    message.secure = object.secure ?? false;
    message.licenceKey = object.licenceKey ?? "";
    message.connType = object.connType ?? 0;
    message.token = object.token ?? "";
    return message;
  },
};

function createBaseRelayResponse(): RelayResponse {
  return {
    socketAddr: new Uint8Array(0),
    uuid: "",
    relayServer: "",
    id: undefined,
    pk: undefined,
    refuseReason: "",
    version: "",
  };
}

export const RelayResponse: MessageFns<RelayResponse> = {
  encode(message: RelayResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.socketAddr.length !== 0) {
      writer.uint32(10).bytes(message.socketAddr);
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    if (message.relayServer !== "") {
      writer.uint32(26).string(message.relayServer);
    }
    if (message.id !== undefined) {
      writer.uint32(34).string(message.id);
    }
    if (message.pk !== undefined) {
      writer.uint32(42).bytes(message.pk);
    }
    if (message.refuseReason !== "") {
      writer.uint32(50).string(message.refuseReason);
    }
    if (message.version !== "") {
      writer.uint32(58).string(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RelayResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseRelayResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.socketAddr = reader.bytes();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.uuid = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.relayServer = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.id = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.pk = reader.bytes();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.refuseReason = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.version = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<RelayResponse>): RelayResponse {
    return RelayResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RelayResponse>): RelayResponse {
    const message = createBaseRelayResponse();
    message.socketAddr = object.socketAddr ?? new Uint8Array(0);
    message.uuid = object.uuid ?? "";
    message.relayServer = object.relayServer ?? "";
    message.id = object.id ?? undefined;
    message.pk = object.pk ?? undefined;
    message.refuseReason = object.refuseReason ?? "";
    message.version = object.version ?? "";
    return message;
  },
};

function createBaseRendezvousMessage(): RendezvousMessage {
  return {
    punchHoleRequest: undefined,
    punchHoleResponse: undefined,
    requestRelay: undefined,
    relayResponse: undefined,
  };
}

export const RendezvousMessage: MessageFns<RendezvousMessage> = {
  encode(message: RendezvousMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.punchHoleRequest !== undefined) {
      PunchHoleRequest.encode(message.punchHoleRequest, writer.uint32(66).fork()).join();
    }
    if (message.punchHoleResponse !== undefined) {
      PunchHoleResponse.encode(message.punchHoleResponse, writer.uint32(90).fork()).join();
    }
    if (message.requestRelay !== undefined) {
      RequestRelay.encode(message.requestRelay, writer.uint32(146).fork()).join();
    }
    if (message.relayResponse !== undefined) {
      RelayResponse.encode(message.relayResponse, writer.uint32(154).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RendezvousMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseRendezvousMessage();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.punchHoleRequest = PunchHoleRequest.decode(reader, reader.uint32());
            continue;
          }
          case 11: {
            if (tag !== 90) {
              break;
            }

            message.punchHoleResponse = PunchHoleResponse.decode(reader, reader.uint32());
            continue;
          }
          case 18: {
            if (tag !== 146) {
              break;
            }

            message.requestRelay = RequestRelay.decode(reader, reader.uint32());
            continue;
          }
          case 19: {
            if (tag !== 154) {
              break;
            }

            message.relayResponse = RelayResponse.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<RendezvousMessage>): RendezvousMessage {
    return RendezvousMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RendezvousMessage>): RendezvousMessage {
    const message = createBaseRendezvousMessage();
    message.punchHoleRequest = (object.punchHoleRequest !== undefined && object.punchHoleRequest !== null)
      ? PunchHoleRequest.fromPartial(object.punchHoleRequest)
      : undefined;
    message.punchHoleResponse = (object.punchHoleResponse !== undefined && object.punchHoleResponse !== null)
      ? PunchHoleResponse.fromPartial(object.punchHoleResponse)
      : undefined;
    message.requestRelay = (object.requestRelay !== undefined && object.requestRelay !== null)
      ? RequestRelay.fromPartial(object.requestRelay)
      : undefined;
    message.relayResponse = (object.relayResponse !== undefined && object.relayResponse !== null)
      ? RelayResponse.fromPartial(object.relayResponse)
      : undefined;
    return message;
  },
};

function createBaseEncodedVideoFrame(): EncodedVideoFrame {
  return { data: new Uint8Array(0), key: false, pts: 0n };
}

export const EncodedVideoFrame: MessageFns<EncodedVideoFrame> = {
  encode(message: EncodedVideoFrame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    if (message.key !== false) {
      writer.uint32(16).bool(message.key);
    }
    if (message.pts !== 0n) {
      if (BigInt.asIntN(64, message.pts) !== message.pts) {
        throw new globalThis.Error("value provided for field message.pts of type int64 too large");
      }
      writer.uint32(24).int64(message.pts);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EncodedVideoFrame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseEncodedVideoFrame();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.data = reader.bytes();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.key = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.pts = reader.int64() as bigint;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<EncodedVideoFrame>): EncodedVideoFrame {
    return EncodedVideoFrame.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EncodedVideoFrame>): EncodedVideoFrame {
    const message = createBaseEncodedVideoFrame();
    message.data = object.data ?? new Uint8Array(0);
    message.key = object.key ?? false;
    message.pts = (object.pts !== undefined && object.pts !== null) ? BigInt(object.pts) : 0n;
    return message;
  },
};

function createBaseEncodedVideoFrames(): EncodedVideoFrames {
  return { frames: [] };
}

export const EncodedVideoFrames: MessageFns<EncodedVideoFrames> = {
  encode(message: EncodedVideoFrames, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.frames) {
      EncodedVideoFrame.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EncodedVideoFrames {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseEncodedVideoFrames();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.frames.push(EncodedVideoFrame.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<EncodedVideoFrames>): EncodedVideoFrames {
    return EncodedVideoFrames.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EncodedVideoFrames>): EncodedVideoFrames {
    const message = createBaseEncodedVideoFrames();
    message.frames = object.frames?.map((e) => EncodedVideoFrame.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVideoFrame(): VideoFrame {
  return { vp9s: undefined, display: 0 };
}

export const VideoFrame: MessageFns<VideoFrame> = {
  encode(message: VideoFrame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vp9s !== undefined) {
      EncodedVideoFrames.encode(message.vp9s, writer.uint32(50).fork()).join();
    }
    if (message.display !== 0) {
      writer.uint32(112).int32(message.display);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoFrame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseVideoFrame();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.vp9s = EncodedVideoFrames.decode(reader, reader.uint32());
            continue;
          }
          case 14: {
            if (tag !== 112) {
              break;
            }

            message.display = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<VideoFrame>): VideoFrame {
    return VideoFrame.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VideoFrame>): VideoFrame {
    const message = createBaseVideoFrame();
    message.vp9s = (object.vp9s !== undefined && object.vp9s !== null)
      ? EncodedVideoFrames.fromPartial(object.vp9s)
      : undefined;
    message.display = object.display ?? 0;
    return message;
  },
};

function createBaseIdPk(): IdPk {
  return { id: "", pk: new Uint8Array(0) };
}

export const IdPk: MessageFns<IdPk> = {
  encode(message: IdPk, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.pk.length !== 0) {
      writer.uint32(18).bytes(message.pk);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IdPk {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseIdPk();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.id = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.pk = reader.bytes();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<IdPk>): IdPk {
    return IdPk.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IdPk>): IdPk {
    const message = createBaseIdPk();
    message.id = object.id ?? "";
    message.pk = object.pk ?? new Uint8Array(0);
    return message;
  },
};

function createBaseDisplayInfo(): DisplayInfo {
  return { x: 0, y: 0, width: 0, height: 0, name: "", online: false };
}

export const DisplayInfo: MessageFns<DisplayInfo> = {
  encode(message: DisplayInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).sint32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).sint32(message.y);
    }
    if (message.width !== 0) {
      writer.uint32(24).int32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(32).int32(message.height);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.online !== false) {
      writer.uint32(48).bool(message.online);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisplayInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDisplayInfo();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.x = reader.sint32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.y = reader.sint32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.width = reader.int32();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.height = reader.int32();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.name = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 48) {
              break;
            }

            message.online = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<DisplayInfo>): DisplayInfo {
    return DisplayInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DisplayInfo>): DisplayInfo {
    const message = createBaseDisplayInfo();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.name = object.name ?? "";
    message.online = object.online ?? false;
    return message;
  },
};

function createBaseFeatures(): Features {
  return { privacyMode: false, terminal: false };
}

export const Features: MessageFns<Features> = {
  encode(message: Features, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.privacyMode !== false) {
      writer.uint32(8).bool(message.privacyMode);
    }
    if (message.terminal !== false) {
      writer.uint32(16).bool(message.terminal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Features {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseFeatures();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.privacyMode = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.terminal = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<Features>): Features {
    return Features.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Features>): Features {
    const message = createBaseFeatures();
    message.privacyMode = object.privacyMode ?? false;
    message.terminal = object.terminal ?? false;
    return message;
  },
};

function createBasePeerInfo(): PeerInfo {
  return {
    username: "",
    hostname: "",
    platform: "",
    displays: [],
    currentDisplay: 0,
    sasEnabled: false,
    version: "",
    features: undefined,
  };
}

export const PeerInfo: MessageFns<PeerInfo> = {
  encode(message: PeerInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.username !== "") {
      writer.uint32(10).string(message.username);
    }
    if (message.hostname !== "") {
      writer.uint32(18).string(message.hostname);
    }
    if (message.platform !== "") {
      writer.uint32(26).string(message.platform);
    }
    for (const v of message.displays) {
      DisplayInfo.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.currentDisplay !== 0) {
      writer.uint32(40).int32(message.currentDisplay);
    }
    if (message.sasEnabled !== false) {
      writer.uint32(48).bool(message.sasEnabled);
    }
    if (message.version !== "") {
      writer.uint32(58).string(message.version);
    }
    if (message.features !== undefined) {
      Features.encode(message.features, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PeerInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePeerInfo();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.username = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.hostname = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.platform = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.displays.push(DisplayInfo.decode(reader, reader.uint32()));
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.currentDisplay = reader.int32();
            continue;
          }
          case 6: {
            if (tag !== 48) {
              break;
            }

            message.sasEnabled = reader.bool();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.version = reader.string();
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.features = Features.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<PeerInfo>): PeerInfo {
    return PeerInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PeerInfo>): PeerInfo {
    const message = createBasePeerInfo();
    message.username = object.username ?? "";
    message.hostname = object.hostname ?? "";
    message.platform = object.platform ?? "";
    message.displays = object.displays?.map((e) => DisplayInfo.fromPartial(e)) || [];
    message.currentDisplay = object.currentDisplay ?? 0;
    message.sasEnabled = object.sasEnabled ?? false;
    message.version = object.version ?? "";
    message.features = (object.features !== undefined && object.features !== null)
      ? Features.fromPartial(object.features)
      : undefined;
    return message;
  },
};

function createBaseCodecAbility(): CodecAbility {
  return { vp8: false, vp9: false, av1: false, h264: false, h265: false };
}

export const CodecAbility: MessageFns<CodecAbility> = {
  encode(message: CodecAbility, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vp8 !== false) {
      writer.uint32(8).bool(message.vp8);
    }
    if (message.vp9 !== false) {
      writer.uint32(16).bool(message.vp9);
    }
    if (message.av1 !== false) {
      writer.uint32(24).bool(message.av1);
    }
    if (message.h264 !== false) {
      writer.uint32(32).bool(message.h264);
    }
    if (message.h265 !== false) {
      writer.uint32(40).bool(message.h265);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CodecAbility {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCodecAbility();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.vp8 = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.vp9 = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.av1 = reader.bool();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.h264 = reader.bool();
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.h265 = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CodecAbility>): CodecAbility {
    return CodecAbility.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CodecAbility>): CodecAbility {
    const message = createBaseCodecAbility();
    message.vp8 = object.vp8 ?? false;
    message.vp9 = object.vp9 ?? false;
    message.av1 = object.av1 ?? false;
    message.h264 = object.h264 ?? false;
    message.h265 = object.h265 ?? false;
    return message;
  },
};

function createBaseSupportedDecoding(): SupportedDecoding {
  return { abilityVp9: 0, abilityH264: 0, abilityH265: 0, prefer: 0, abilityVp8: 0, abilityAv1: 0, i444: undefined };
}

export const SupportedDecoding: MessageFns<SupportedDecoding> = {
  encode(message: SupportedDecoding, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.abilityVp9 !== 0) {
      writer.uint32(8).int32(message.abilityVp9);
    }
    if (message.abilityH264 !== 0) {
      writer.uint32(16).int32(message.abilityH264);
    }
    if (message.abilityH265 !== 0) {
      writer.uint32(24).int32(message.abilityH265);
    }
    if (message.prefer !== 0) {
      writer.uint32(32).int32(message.prefer);
    }
    if (message.abilityVp8 !== 0) {
      writer.uint32(40).int32(message.abilityVp8);
    }
    if (message.abilityAv1 !== 0) {
      writer.uint32(48).int32(message.abilityAv1);
    }
    if (message.i444 !== undefined) {
      CodecAbility.encode(message.i444, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SupportedDecoding {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseSupportedDecoding();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.abilityVp9 = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.abilityH264 = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.abilityH265 = reader.int32();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.prefer = reader.int32() as any;
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.abilityVp8 = reader.int32();
            continue;
          }
          case 6: {
            if (tag !== 48) {
              break;
            }

            message.abilityAv1 = reader.int32();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.i444 = CodecAbility.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<SupportedDecoding>): SupportedDecoding {
    return SupportedDecoding.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SupportedDecoding>): SupportedDecoding {
    const message = createBaseSupportedDecoding();
    message.abilityVp9 = object.abilityVp9 ?? 0;
    message.abilityH264 = object.abilityH264 ?? 0;
    message.abilityH265 = object.abilityH265 ?? 0;
    message.prefer = object.prefer ?? 0;
    message.abilityVp8 = object.abilityVp8 ?? 0;
    message.abilityAv1 = object.abilityAv1 ?? 0;
    message.i444 = (object.i444 !== undefined && object.i444 !== null)
      ? CodecAbility.fromPartial(object.i444)
      : undefined;
    return message;
  },
};

function createBaseOptionMessage(): OptionMessage {
  return {
    imageQuality: 0,
    showRemoteCursor: 0,
    disableAudio: 0,
    disableClipboard: 0,
    supportedDecoding: undefined,
    disableKeyboard: 0,
  };
}

export const OptionMessage: MessageFns<OptionMessage> = {
  encode(message: OptionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.imageQuality !== 0) {
      writer.uint32(8).int32(message.imageQuality);
    }
    if (message.showRemoteCursor !== 0) {
      writer.uint32(24).int32(message.showRemoteCursor);
    }
    if (message.disableAudio !== 0) {
      writer.uint32(56).int32(message.disableAudio);
    }
    if (message.disableClipboard !== 0) {
      writer.uint32(64).int32(message.disableClipboard);
    }
    if (message.supportedDecoding !== undefined) {
      SupportedDecoding.encode(message.supportedDecoding, writer.uint32(82).fork()).join();
    }
    if (message.disableKeyboard !== 0) {
      writer.uint32(96).int32(message.disableKeyboard);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseOptionMessage();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.imageQuality = reader.int32() as any;
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.showRemoteCursor = reader.int32() as any;
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.disableAudio = reader.int32() as any;
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.disableClipboard = reader.int32() as any;
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.supportedDecoding = SupportedDecoding.decode(reader, reader.uint32());
            continue;
          }
          case 12: {
            if (tag !== 96) {
              break;
            }

            message.disableKeyboard = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<OptionMessage>): OptionMessage {
    return OptionMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OptionMessage>): OptionMessage {
    const message = createBaseOptionMessage();
    message.imageQuality = object.imageQuality ?? 0;
    message.showRemoteCursor = object.showRemoteCursor ?? 0;
    message.disableAudio = object.disableAudio ?? 0;
    message.disableClipboard = object.disableClipboard ?? 0;
    message.supportedDecoding = (object.supportedDecoding !== undefined && object.supportedDecoding !== null)
      ? SupportedDecoding.fromPartial(object.supportedDecoding)
      : undefined;
    message.disableKeyboard = object.disableKeyboard ?? 0;
    return message;
  },
};

function createBaseLoginRequest(): LoginRequest {
  return {
    username: "",
    password: new Uint8Array(0),
    myId: "",
    myName: "",
    option: undefined,
    videoAckRequired: false,
    version: "",
    myPlatform: "",
  };
}

export const LoginRequest: MessageFns<LoginRequest> = {
  encode(message: LoginRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.username !== "") {
      writer.uint32(10).string(message.username);
    }
    if (message.password.length !== 0) {
      writer.uint32(18).bytes(message.password);
    }
    if (message.myId !== "") {
      writer.uint32(34).string(message.myId);
    }
    if (message.myName !== "") {
      writer.uint32(42).string(message.myName);
    }
    if (message.option !== undefined) {
      OptionMessage.encode(message.option, writer.uint32(50).fork()).join();
    }
    if (message.videoAckRequired !== false) {
      writer.uint32(72).bool(message.videoAckRequired);
    }
    if (message.version !== "") {
      writer.uint32(90).string(message.version);
    }
    if (message.myPlatform !== "") {
      writer.uint32(106).string(message.myPlatform);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoginRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLoginRequest();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.username = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.password = reader.bytes();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.myId = reader.string();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.myName = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.option = OptionMessage.decode(reader, reader.uint32());
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.videoAckRequired = reader.bool();
            continue;
          }
          case 11: {
            if (tag !== 90) {
              break;
            }

            message.version = reader.string();
            continue;
          }
          case 13: {
            if (tag !== 106) {
              break;
            }

            message.myPlatform = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<LoginRequest>): LoginRequest {
    return LoginRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LoginRequest>): LoginRequest {
    const message = createBaseLoginRequest();
    message.username = object.username ?? "";
    message.password = object.password ?? new Uint8Array(0);
    message.myId = object.myId ?? "";
    message.myName = object.myName ?? "";
    message.option = (object.option !== undefined && object.option !== null)
      ? OptionMessage.fromPartial(object.option)
      : undefined;
    message.videoAckRequired = object.videoAckRequired ?? false;
    message.version = object.version ?? "";
    message.myPlatform = object.myPlatform ?? "";
    return message;
  },
};

function createBaseLoginResponse(): LoginResponse {
  return { error: undefined, peerInfo: undefined };
}

export const LoginResponse: MessageFns<LoginResponse> = {
  encode(message: LoginResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.error !== undefined) {
      writer.uint32(10).string(message.error);
    }
    if (message.peerInfo !== undefined) {
      PeerInfo.encode(message.peerInfo, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoginResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseLoginResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.error = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.peerInfo = PeerInfo.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<LoginResponse>): LoginResponse {
    return LoginResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LoginResponse>): LoginResponse {
    const message = createBaseLoginResponse();
    message.error = object.error ?? undefined;
    message.peerInfo = (object.peerInfo !== undefined && object.peerInfo !== null)
      ? PeerInfo.fromPartial(object.peerInfo)
      : undefined;
    return message;
  },
};

function createBaseHash(): Hash {
  return { salt: "", challenge: "" };
}

export const Hash: MessageFns<Hash> = {
  encode(message: Hash, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.salt !== "") {
      writer.uint32(10).string(message.salt);
    }
    if (message.challenge !== "") {
      writer.uint32(18).string(message.challenge);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Hash {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseHash();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.salt = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.challenge = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<Hash>): Hash {
    return Hash.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Hash>): Hash {
    const message = createBaseHash();
    message.salt = object.salt ?? "";
    message.challenge = object.challenge ?? "";
    return message;
  },
};

function createBaseAudioFrame(): AudioFrame {
  return { data: new Uint8Array(0) };
}

export const AudioFrame: MessageFns<AudioFrame> = {
  encode(message: AudioFrame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AudioFrame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAudioFrame();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.data = reader.bytes();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<AudioFrame>): AudioFrame {
    return AudioFrame.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AudioFrame>): AudioFrame {
    const message = createBaseAudioFrame();
    message.data = object.data ?? new Uint8Array(0);
    return message;
  },
};

function createBaseClipboard(): Clipboard {
  return { compress: false, content: new Uint8Array(0), width: 0, height: 0, format: 0, specialName: "" };
}

export const Clipboard: MessageFns<Clipboard> = {
  encode(message: Clipboard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.compress !== false) {
      writer.uint32(8).bool(message.compress);
    }
    if (message.content.length !== 0) {
      writer.uint32(18).bytes(message.content);
    }
    if (message.width !== 0) {
      writer.uint32(24).int32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(32).int32(message.height);
    }
    if (message.format !== 0) {
      writer.uint32(40).int32(message.format);
    }
    if (message.specialName !== "") {
      writer.uint32(50).string(message.specialName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Clipboard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseClipboard();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.compress = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.content = reader.bytes();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.width = reader.int32();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.height = reader.int32();
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.format = reader.int32() as any;
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.specialName = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<Clipboard>): Clipboard {
    return Clipboard.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Clipboard>): Clipboard {
    const message = createBaseClipboard();
    message.compress = object.compress ?? false;
    message.content = object.content ?? new Uint8Array(0);
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.format = object.format ?? 0;
    message.specialName = object.specialName ?? "";
    return message;
  },
};

function createBaseCliprdrMonitorReady(): CliprdrMonitorReady {
  return {};
}

export const CliprdrMonitorReady: MessageFns<CliprdrMonitorReady> = {
  encode(_: CliprdrMonitorReady, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrMonitorReady {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrMonitorReady();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrMonitorReady>): CliprdrMonitorReady {
    return CliprdrMonitorReady.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<CliprdrMonitorReady>): CliprdrMonitorReady {
    const message = createBaseCliprdrMonitorReady();
    return message;
  },
};

function createBaseCliprdrFormat(): CliprdrFormat {
  return { id: 0, format: "" };
}

export const CliprdrFormat: MessageFns<CliprdrFormat> = {
  encode(message: CliprdrFormat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(16).int32(message.id);
    }
    if (message.format !== "") {
      writer.uint32(26).string(message.format);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrFormat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrFormat();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.id = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.format = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrFormat>): CliprdrFormat {
    return CliprdrFormat.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrFormat>): CliprdrFormat {
    const message = createBaseCliprdrFormat();
    message.id = object.id ?? 0;
    message.format = object.format ?? "";
    return message;
  },
};

function createBaseCliprdrServerFormatList(): CliprdrServerFormatList {
  return { formats: [] };
}

export const CliprdrServerFormatList: MessageFns<CliprdrServerFormatList> = {
  encode(message: CliprdrServerFormatList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.formats) {
      CliprdrFormat.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrServerFormatList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrServerFormatList();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.formats.push(CliprdrFormat.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrServerFormatList>): CliprdrServerFormatList {
    return CliprdrServerFormatList.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrServerFormatList>): CliprdrServerFormatList {
    const message = createBaseCliprdrServerFormatList();
    message.formats = object.formats?.map((e) => CliprdrFormat.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCliprdrServerFormatListResponse(): CliprdrServerFormatListResponse {
  return { msgFlags: 0 };
}

export const CliprdrServerFormatListResponse: MessageFns<CliprdrServerFormatListResponse> = {
  encode(message: CliprdrServerFormatListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.msgFlags !== 0) {
      writer.uint32(16).int32(message.msgFlags);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrServerFormatListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrServerFormatListResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.msgFlags = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrServerFormatListResponse>): CliprdrServerFormatListResponse {
    return CliprdrServerFormatListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrServerFormatListResponse>): CliprdrServerFormatListResponse {
    const message = createBaseCliprdrServerFormatListResponse();
    message.msgFlags = object.msgFlags ?? 0;
    return message;
  },
};

function createBaseCliprdrServerFormatDataRequest(): CliprdrServerFormatDataRequest {
  return { requestedFormatId: 0 };
}

export const CliprdrServerFormatDataRequest: MessageFns<CliprdrServerFormatDataRequest> = {
  encode(message: CliprdrServerFormatDataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.requestedFormatId !== 0) {
      writer.uint32(16).int32(message.requestedFormatId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrServerFormatDataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrServerFormatDataRequest();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.requestedFormatId = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrServerFormatDataRequest>): CliprdrServerFormatDataRequest {
    return CliprdrServerFormatDataRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrServerFormatDataRequest>): CliprdrServerFormatDataRequest {
    const message = createBaseCliprdrServerFormatDataRequest();
    message.requestedFormatId = object.requestedFormatId ?? 0;
    return message;
  },
};

function createBaseCliprdrServerFormatDataResponse(): CliprdrServerFormatDataResponse {
  return { msgFlags: 0, formatData: new Uint8Array(0) };
}

export const CliprdrServerFormatDataResponse: MessageFns<CliprdrServerFormatDataResponse> = {
  encode(message: CliprdrServerFormatDataResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.msgFlags !== 0) {
      writer.uint32(16).int32(message.msgFlags);
    }
    if (message.formatData.length !== 0) {
      writer.uint32(26).bytes(message.formatData);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrServerFormatDataResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrServerFormatDataResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.msgFlags = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.formatData = reader.bytes();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrServerFormatDataResponse>): CliprdrServerFormatDataResponse {
    return CliprdrServerFormatDataResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrServerFormatDataResponse>): CliprdrServerFormatDataResponse {
    const message = createBaseCliprdrServerFormatDataResponse();
    message.msgFlags = object.msgFlags ?? 0;
    message.formatData = object.formatData ?? new Uint8Array(0);
    return message;
  },
};

function createBaseCliprdrFileContentsRequest(): CliprdrFileContentsRequest {
  return {
    streamId: 0,
    listIndex: 0,
    dwFlags: 0,
    nPositionLow: 0,
    nPositionHigh: 0,
    cbRequested: 0,
    haveClipDataId: false,
    clipDataId: 0,
  };
}

export const CliprdrFileContentsRequest: MessageFns<CliprdrFileContentsRequest> = {
  encode(message: CliprdrFileContentsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.streamId !== 0) {
      writer.uint32(16).int32(message.streamId);
    }
    if (message.listIndex !== 0) {
      writer.uint32(24).int32(message.listIndex);
    }
    if (message.dwFlags !== 0) {
      writer.uint32(32).int32(message.dwFlags);
    }
    if (message.nPositionLow !== 0) {
      writer.uint32(40).int32(message.nPositionLow);
    }
    if (message.nPositionHigh !== 0) {
      writer.uint32(48).int32(message.nPositionHigh);
    }
    if (message.cbRequested !== 0) {
      writer.uint32(56).int32(message.cbRequested);
    }
    if (message.haveClipDataId !== false) {
      writer.uint32(64).bool(message.haveClipDataId);
    }
    if (message.clipDataId !== 0) {
      writer.uint32(72).int32(message.clipDataId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrFileContentsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrFileContentsRequest();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.streamId = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.listIndex = reader.int32();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.dwFlags = reader.int32();
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.nPositionLow = reader.int32();
            continue;
          }
          case 6: {
            if (tag !== 48) {
              break;
            }

            message.nPositionHigh = reader.int32();
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.cbRequested = reader.int32();
            continue;
          }
          case 8: {
            if (tag !== 64) {
              break;
            }

            message.haveClipDataId = reader.bool();
            continue;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.clipDataId = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrFileContentsRequest>): CliprdrFileContentsRequest {
    return CliprdrFileContentsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrFileContentsRequest>): CliprdrFileContentsRequest {
    const message = createBaseCliprdrFileContentsRequest();
    message.streamId = object.streamId ?? 0;
    message.listIndex = object.listIndex ?? 0;
    message.dwFlags = object.dwFlags ?? 0;
    message.nPositionLow = object.nPositionLow ?? 0;
    message.nPositionHigh = object.nPositionHigh ?? 0;
    message.cbRequested = object.cbRequested ?? 0;
    message.haveClipDataId = object.haveClipDataId ?? false;
    message.clipDataId = object.clipDataId ?? 0;
    return message;
  },
};

function createBaseCliprdrFileContentsResponse(): CliprdrFileContentsResponse {
  return { msgFlags: 0, streamId: 0, requestedData: new Uint8Array(0) };
}

export const CliprdrFileContentsResponse: MessageFns<CliprdrFileContentsResponse> = {
  encode(message: CliprdrFileContentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.msgFlags !== 0) {
      writer.uint32(24).int32(message.msgFlags);
    }
    if (message.streamId !== 0) {
      writer.uint32(32).int32(message.streamId);
    }
    if (message.requestedData.length !== 0) {
      writer.uint32(42).bytes(message.requestedData);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrFileContentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrFileContentsResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.msgFlags = reader.int32();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.streamId = reader.int32();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.requestedData = reader.bytes();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrFileContentsResponse>): CliprdrFileContentsResponse {
    return CliprdrFileContentsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrFileContentsResponse>): CliprdrFileContentsResponse {
    const message = createBaseCliprdrFileContentsResponse();
    message.msgFlags = object.msgFlags ?? 0;
    message.streamId = object.streamId ?? 0;
    message.requestedData = object.requestedData ?? new Uint8Array(0);
    return message;
  },
};

function createBaseCliprdrTryEmpty(): CliprdrTryEmpty {
  return {};
}

export const CliprdrTryEmpty: MessageFns<CliprdrTryEmpty> = {
  encode(_: CliprdrTryEmpty, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrTryEmpty {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrTryEmpty();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrTryEmpty>): CliprdrTryEmpty {
    return CliprdrTryEmpty.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<CliprdrTryEmpty>): CliprdrTryEmpty {
    const message = createBaseCliprdrTryEmpty();
    return message;
  },
};

function createBaseCliprdrFile(): CliprdrFile {
  return { name: "", size: 0n };
}

export const CliprdrFile: MessageFns<CliprdrFile> = {
  encode(message: CliprdrFile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.size !== 0n) {
      if (BigInt.asUintN(64, message.size) !== message.size) {
        throw new globalThis.Error("value provided for field message.size of type uint64 too large");
      }
      writer.uint32(16).uint64(message.size);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrFile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrFile();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.name = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.size = reader.uint64() as bigint;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrFile>): CliprdrFile {
    return CliprdrFile.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrFile>): CliprdrFile {
    const message = createBaseCliprdrFile();
    message.name = object.name ?? "";
    message.size = (object.size !== undefined && object.size !== null) ? BigInt(object.size) : 0n;
    return message;
  },
};

function createBaseCliprdrFiles(): CliprdrFiles {
  return { files: [] };
}

export const CliprdrFiles: MessageFns<CliprdrFiles> = {
  encode(message: CliprdrFiles, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.files) {
      CliprdrFile.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CliprdrFiles {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdrFiles();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.files.push(CliprdrFile.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CliprdrFiles>): CliprdrFiles {
    return CliprdrFiles.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CliprdrFiles>): CliprdrFiles {
    const message = createBaseCliprdrFiles();
    message.files = object.files?.map((e) => CliprdrFile.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCliprdr(): Cliprdr {
  return {
    ready: undefined,
    formatList: undefined,
    formatListResponse: undefined,
    formatDataRequest: undefined,
    formatDataResponse: undefined,
    fileContentsRequest: undefined,
    fileContentsResponse: undefined,
    tryEmpty: undefined,
    files: undefined,
  };
}

export const Cliprdr: MessageFns<Cliprdr> = {
  encode(message: Cliprdr, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ready !== undefined) {
      CliprdrMonitorReady.encode(message.ready, writer.uint32(10).fork()).join();
    }
    if (message.formatList !== undefined) {
      CliprdrServerFormatList.encode(message.formatList, writer.uint32(18).fork()).join();
    }
    if (message.formatListResponse !== undefined) {
      CliprdrServerFormatListResponse.encode(message.formatListResponse, writer.uint32(26).fork()).join();
    }
    if (message.formatDataRequest !== undefined) {
      CliprdrServerFormatDataRequest.encode(message.formatDataRequest, writer.uint32(34).fork()).join();
    }
    if (message.formatDataResponse !== undefined) {
      CliprdrServerFormatDataResponse.encode(message.formatDataResponse, writer.uint32(42).fork()).join();
    }
    if (message.fileContentsRequest !== undefined) {
      CliprdrFileContentsRequest.encode(message.fileContentsRequest, writer.uint32(50).fork()).join();
    }
    if (message.fileContentsResponse !== undefined) {
      CliprdrFileContentsResponse.encode(message.fileContentsResponse, writer.uint32(58).fork()).join();
    }
    if (message.tryEmpty !== undefined) {
      CliprdrTryEmpty.encode(message.tryEmpty, writer.uint32(66).fork()).join();
    }
    if (message.files !== undefined) {
      CliprdrFiles.encode(message.files, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Cliprdr {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCliprdr();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.ready = CliprdrMonitorReady.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.formatList = CliprdrServerFormatList.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.formatListResponse = CliprdrServerFormatListResponse.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.formatDataRequest = CliprdrServerFormatDataRequest.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.formatDataResponse = CliprdrServerFormatDataResponse.decode(reader, reader.uint32());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.fileContentsRequest = CliprdrFileContentsRequest.decode(reader, reader.uint32());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.fileContentsResponse = CliprdrFileContentsResponse.decode(reader, reader.uint32());
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.tryEmpty = CliprdrTryEmpty.decode(reader, reader.uint32());
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.files = CliprdrFiles.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<Cliprdr>): Cliprdr {
    return Cliprdr.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Cliprdr>): Cliprdr {
    const message = createBaseCliprdr();
    message.ready = (object.ready !== undefined && object.ready !== null)
      ? CliprdrMonitorReady.fromPartial(object.ready)
      : undefined;
    message.formatList = (object.formatList !== undefined && object.formatList !== null)
      ? CliprdrServerFormatList.fromPartial(object.formatList)
      : undefined;
    message.formatListResponse = (object.formatListResponse !== undefined && object.formatListResponse !== null)
      ? CliprdrServerFormatListResponse.fromPartial(object.formatListResponse)
      : undefined;
    message.formatDataRequest = (object.formatDataRequest !== undefined && object.formatDataRequest !== null)
      ? CliprdrServerFormatDataRequest.fromPartial(object.formatDataRequest)
      : undefined;
    message.formatDataResponse = (object.formatDataResponse !== undefined && object.formatDataResponse !== null)
      ? CliprdrServerFormatDataResponse.fromPartial(object.formatDataResponse)
      : undefined;
    message.fileContentsRequest = (object.fileContentsRequest !== undefined && object.fileContentsRequest !== null)
      ? CliprdrFileContentsRequest.fromPartial(object.fileContentsRequest)
      : undefined;
    message.fileContentsResponse = (object.fileContentsResponse !== undefined && object.fileContentsResponse !== null)
      ? CliprdrFileContentsResponse.fromPartial(object.fileContentsResponse)
      : undefined;
    message.tryEmpty = (object.tryEmpty !== undefined && object.tryEmpty !== null)
      ? CliprdrTryEmpty.fromPartial(object.tryEmpty)
      : undefined;
    message.files = (object.files !== undefined && object.files !== null)
      ? CliprdrFiles.fromPartial(object.files)
      : undefined;
    return message;
  },
};

function createBasePublicKey(): PublicKey {
  return { asymmetricValue: new Uint8Array(0), symmetricValue: new Uint8Array(0) };
}

export const PublicKey: MessageFns<PublicKey> = {
  encode(message: PublicKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asymmetricValue.length !== 0) {
      writer.uint32(10).bytes(message.asymmetricValue);
    }
    if (message.symmetricValue.length !== 0) {
      writer.uint32(18).bytes(message.symmetricValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PublicKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBasePublicKey();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.asymmetricValue = reader.bytes();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.symmetricValue = reader.bytes();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<PublicKey>): PublicKey {
    return PublicKey.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PublicKey>): PublicKey {
    const message = createBasePublicKey();
    message.asymmetricValue = object.asymmetricValue ?? new Uint8Array(0);
    message.symmetricValue = object.symmetricValue ?? new Uint8Array(0);
    return message;
  },
};

function createBaseSignedId(): SignedId {
  return { id: new Uint8Array(0) };
}

export const SignedId: MessageFns<SignedId> = {
  encode(message: SignedId, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id.length !== 0) {
      writer.uint32(10).bytes(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignedId {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseSignedId();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.id = reader.bytes();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<SignedId>): SignedId {
    return SignedId.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SignedId>): SignedId {
    const message = createBaseSignedId();
    message.id = object.id ?? new Uint8Array(0);
    return message;
  },
};

function createBaseTestDelay(): TestDelay {
  return { time: 0n, fromClient: false, lastDelay: 0, targetBitrate: 0 };
}

export const TestDelay: MessageFns<TestDelay> = {
  encode(message: TestDelay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.time !== 0n) {
      if (BigInt.asIntN(64, message.time) !== message.time) {
        throw new globalThis.Error("value provided for field message.time of type int64 too large");
      }
      writer.uint32(8).int64(message.time);
    }
    if (message.fromClient !== false) {
      writer.uint32(16).bool(message.fromClient);
    }
    if (message.lastDelay !== 0) {
      writer.uint32(24).uint32(message.lastDelay);
    }
    if (message.targetBitrate !== 0) {
      writer.uint32(32).uint32(message.targetBitrate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TestDelay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseTestDelay();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.time = reader.int64() as bigint;
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.fromClient = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.lastDelay = reader.uint32();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.targetBitrate = reader.uint32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<TestDelay>): TestDelay {
    return TestDelay.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TestDelay>): TestDelay {
    const message = createBaseTestDelay();
    message.time = (object.time !== undefined && object.time !== null) ? BigInt(object.time) : 0n;
    message.fromClient = object.fromClient ?? false;
    message.lastDelay = object.lastDelay ?? 0;
    message.targetBitrate = object.targetBitrate ?? 0;
    return message;
  },
};

function createBaseCursorData(): CursorData {
  return { id: 0n, hotx: 0, hoty: 0, width: 0, height: 0, colors: new Uint8Array(0) };
}

export const CursorData: MessageFns<CursorData> = {
  encode(message: CursorData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0n) {
      if (BigInt.asUintN(64, message.id) !== message.id) {
        throw new globalThis.Error("value provided for field message.id of type uint64 too large");
      }
      writer.uint32(8).uint64(message.id);
    }
    if (message.hotx !== 0) {
      writer.uint32(16).sint32(message.hotx);
    }
    if (message.hoty !== 0) {
      writer.uint32(24).sint32(message.hoty);
    }
    if (message.width !== 0) {
      writer.uint32(32).int32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(40).int32(message.height);
    }
    if (message.colors.length !== 0) {
      writer.uint32(50).bytes(message.colors);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CursorData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCursorData();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.id = reader.uint64() as bigint;
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.hotx = reader.sint32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.hoty = reader.sint32();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.width = reader.int32();
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.height = reader.int32();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.colors = reader.bytes();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CursorData>): CursorData {
    return CursorData.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CursorData>): CursorData {
    const message = createBaseCursorData();
    message.id = (object.id !== undefined && object.id !== null) ? BigInt(object.id) : 0n;
    message.hotx = object.hotx ?? 0;
    message.hoty = object.hoty ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.colors = object.colors ?? new Uint8Array(0);
    return message;
  },
};

function createBaseCursorPosition(): CursorPosition {
  return { x: 0, y: 0 };
}

export const CursorPosition: MessageFns<CursorPosition> = {
  encode(message: CursorPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).sint32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).sint32(message.y);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CursorPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCursorPosition();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.x = reader.sint32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.y = reader.sint32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<CursorPosition>): CursorPosition {
    return CursorPosition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CursorPosition>): CursorPosition {
    const message = createBaseCursorPosition();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    return message;
  },
};

function createBaseMouseEvent(): MouseEvent {
  return { mask: 0, x: 0, y: 0, modifiers: [] };
}

export const MouseEvent: MessageFns<MouseEvent> = {
  encode(message: MouseEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mask !== 0) {
      writer.uint32(8).int32(message.mask);
    }
    if (message.x !== 0) {
      writer.uint32(16).sint32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(24).sint32(message.y);
    }
    writer.uint32(34).fork();
    for (const v of message.modifiers) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MouseEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseMouseEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.mask = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.x = reader.sint32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.y = reader.sint32();
            continue;
          }
          case 4: {
            if (tag === 32) {
              message.modifiers.push(reader.int32() as any);

              continue;
            }

            if (tag === 34) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.modifiers.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<MouseEvent>): MouseEvent {
    return MouseEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MouseEvent>): MouseEvent {
    const message = createBaseMouseEvent();
    message.mask = object.mask ?? 0;
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.modifiers = object.modifiers?.map((e) => e) || [];
    return message;
  },
};

function createBaseKeyEvent(): KeyEvent {
  return {
    down: false,
    press: false,
    controlKey: undefined,
    chr: undefined,
    unicode: undefined,
    seq: undefined,
    win2winHotkey: undefined,
    modifiers: [],
    mode: 0,
  };
}

export const KeyEvent: MessageFns<KeyEvent> = {
  encode(message: KeyEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.down !== false) {
      writer.uint32(8).bool(message.down);
    }
    if (message.press !== false) {
      writer.uint32(16).bool(message.press);
    }
    if (message.controlKey !== undefined) {
      writer.uint32(24).int32(message.controlKey);
    }
    if (message.chr !== undefined) {
      writer.uint32(32).uint32(message.chr);
    }
    if (message.unicode !== undefined) {
      writer.uint32(40).uint32(message.unicode);
    }
    if (message.seq !== undefined) {
      writer.uint32(50).string(message.seq);
    }
    if (message.win2winHotkey !== undefined) {
      writer.uint32(56).uint32(message.win2winHotkey);
    }
    writer.uint32(66).fork();
    for (const v of message.modifiers) {
      writer.int32(v);
    }
    writer.join();
    if (message.mode !== 0) {
      writer.uint32(72).int32(message.mode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseKeyEvent();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.down = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.press = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.controlKey = reader.int32() as any;
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.chr = reader.uint32();
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.unicode = reader.uint32();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.seq = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 56) {
              break;
            }

            message.win2winHotkey = reader.uint32();
            continue;
          }
          case 8: {
            if (tag === 64) {
              message.modifiers.push(reader.int32() as any);

              continue;
            }

            if (tag === 66) {
              const end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) {
                message.modifiers.push(reader.int32() as any);
              }

              continue;
            }

            break;
          }
          case 9: {
            if (tag !== 72) {
              break;
            }

            message.mode = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<KeyEvent>): KeyEvent {
    return KeyEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KeyEvent>): KeyEvent {
    const message = createBaseKeyEvent();
    message.down = object.down ?? false;
    message.press = object.press ?? false;
    message.controlKey = object.controlKey ?? undefined;
    message.chr = object.chr ?? undefined;
    message.unicode = object.unicode ?? undefined;
    message.seq = object.seq ?? undefined;
    message.win2winHotkey = object.win2winHotkey ?? undefined;
    message.modifiers = object.modifiers?.map((e) => e) || [];
    message.mode = object.mode ?? 0;
    return message;
  },
};

function createBaseSwitchDisplay(): SwitchDisplay {
  return { display: 0, x: 0, y: 0, width: 0, height: 0, cursorEmbedded: false };
}

export const SwitchDisplay: MessageFns<SwitchDisplay> = {
  encode(message: SwitchDisplay, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.display !== 0) {
      writer.uint32(8).int32(message.display);
    }
    if (message.x !== 0) {
      writer.uint32(16).sint32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(24).sint32(message.y);
    }
    if (message.width !== 0) {
      writer.uint32(32).int32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(40).int32(message.height);
    }
    if (message.cursorEmbedded !== false) {
      writer.uint32(48).bool(message.cursorEmbedded);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchDisplay {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseSwitchDisplay();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.display = reader.int32();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.x = reader.sint32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.y = reader.sint32();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.width = reader.int32();
            continue;
          }
          case 5: {
            if (tag !== 40) {
              break;
            }

            message.height = reader.int32();
            continue;
          }
          case 6: {
            if (tag !== 48) {
              break;
            }

            message.cursorEmbedded = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<SwitchDisplay>): SwitchDisplay {
    return SwitchDisplay.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SwitchDisplay>): SwitchDisplay {
    const message = createBaseSwitchDisplay();
    message.display = object.display ?? 0;
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.cursorEmbedded = object.cursorEmbedded ?? false;
    return message;
  },
};

function createBaseChatMessage(): ChatMessage {
  return { text: "" };
}

export const ChatMessage: MessageFns<ChatMessage> = {
  encode(message: ChatMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseChatMessage();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.text = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<ChatMessage>): ChatMessage {
    return ChatMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChatMessage>): ChatMessage {
    const message = createBaseChatMessage();
    message.text = object.text ?? "";
    return message;
  },
};

function createBaseMisc(): Misc {
  return {
    chatMessage: undefined,
    switchDisplay: undefined,
    option: undefined,
    closeReason: undefined,
    refreshVideo: undefined,
    videoReceived: undefined,
  };
}

export const Misc: MessageFns<Misc> = {
  encode(message: Misc, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatMessage !== undefined) {
      ChatMessage.encode(message.chatMessage, writer.uint32(34).fork()).join();
    }
    if (message.switchDisplay !== undefined) {
      SwitchDisplay.encode(message.switchDisplay, writer.uint32(42).fork()).join();
    }
    if (message.option !== undefined) {
      OptionMessage.encode(message.option, writer.uint32(58).fork()).join();
    }
    if (message.closeReason !== undefined) {
      writer.uint32(74).string(message.closeReason);
    }
    if (message.refreshVideo !== undefined) {
      writer.uint32(80).bool(message.refreshVideo);
    }
    if (message.videoReceived !== undefined) {
      writer.uint32(96).bool(message.videoReceived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Misc {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseMisc();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.chatMessage = ChatMessage.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.switchDisplay = SwitchDisplay.decode(reader, reader.uint32());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.option = OptionMessage.decode(reader, reader.uint32());
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.closeReason = reader.string();
            continue;
          }
          case 10: {
            if (tag !== 80) {
              break;
            }

            message.refreshVideo = reader.bool();
            continue;
          }
          case 12: {
            if (tag !== 96) {
              break;
            }

            message.videoReceived = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<Misc>): Misc {
    return Misc.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Misc>): Misc {
    const message = createBaseMisc();
    message.chatMessage = (object.chatMessage !== undefined && object.chatMessage !== null)
      ? ChatMessage.fromPartial(object.chatMessage)
      : undefined;
    message.switchDisplay = (object.switchDisplay !== undefined && object.switchDisplay !== null)
      ? SwitchDisplay.fromPartial(object.switchDisplay)
      : undefined;
    message.option = (object.option !== undefined && object.option !== null)
      ? OptionMessage.fromPartial(object.option)
      : undefined;
    message.closeReason = object.closeReason ?? undefined;
    message.refreshVideo = object.refreshVideo ?? undefined;
    message.videoReceived = object.videoReceived ?? undefined;
    return message;
  },
};

function createBaseMessage(): Message {
  return {
    signedId: undefined,
    publicKey: undefined,
    testDelay: undefined,
    videoFrame: undefined,
    loginRequest: undefined,
    loginResponse: undefined,
    hash: undefined,
    mouseEvent: undefined,
    audioFrame: undefined,
    cursorData: undefined,
    cursorPosition: undefined,
    cursorId: undefined,
    keyEvent: undefined,
    clipboard: undefined,
    misc: undefined,
    cliprdr: undefined,
    peerInfo: undefined,
  };
}

export const Message: MessageFns<Message> = {
  encode(message: Message, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.signedId !== undefined) {
      SignedId.encode(message.signedId, writer.uint32(26).fork()).join();
    }
    if (message.publicKey !== undefined) {
      PublicKey.encode(message.publicKey, writer.uint32(34).fork()).join();
    }
    if (message.testDelay !== undefined) {
      TestDelay.encode(message.testDelay, writer.uint32(42).fork()).join();
    }
    if (message.videoFrame !== undefined) {
      VideoFrame.encode(message.videoFrame, writer.uint32(50).fork()).join();
    }
    if (message.loginRequest !== undefined) {
      LoginRequest.encode(message.loginRequest, writer.uint32(58).fork()).join();
    }
    if (message.loginResponse !== undefined) {
      LoginResponse.encode(message.loginResponse, writer.uint32(66).fork()).join();
    }
    if (message.hash !== undefined) {
      Hash.encode(message.hash, writer.uint32(74).fork()).join();
    }
    if (message.mouseEvent !== undefined) {
      MouseEvent.encode(message.mouseEvent, writer.uint32(82).fork()).join();
    }
    if (message.audioFrame !== undefined) {
      AudioFrame.encode(message.audioFrame, writer.uint32(90).fork()).join();
    }
    if (message.cursorData !== undefined) {
      CursorData.encode(message.cursorData, writer.uint32(98).fork()).join();
    }
    if (message.cursorPosition !== undefined) {
      CursorPosition.encode(message.cursorPosition, writer.uint32(106).fork()).join();
    }
    if (message.cursorId !== undefined) {
      if (BigInt.asUintN(64, message.cursorId) !== message.cursorId) {
        throw new globalThis.Error("value provided for field message.cursorId of type uint64 too large");
      }
      writer.uint32(112).uint64(message.cursorId);
    }
    if (message.keyEvent !== undefined) {
      KeyEvent.encode(message.keyEvent, writer.uint32(122).fork()).join();
    }
    if (message.clipboard !== undefined) {
      Clipboard.encode(message.clipboard, writer.uint32(130).fork()).join();
    }
    if (message.misc !== undefined) {
      Misc.encode(message.misc, writer.uint32(154).fork()).join();
    }
    if (message.cliprdr !== undefined) {
      Cliprdr.encode(message.cliprdr, writer.uint32(162).fork()).join();
    }
    if (message.peerInfo !== undefined) {
      PeerInfo.encode(message.peerInfo, writer.uint32(202).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Message {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseMessage();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.signedId = SignedId.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.publicKey = PublicKey.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.testDelay = TestDelay.decode(reader, reader.uint32());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.videoFrame = VideoFrame.decode(reader, reader.uint32());
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.loginRequest = LoginRequest.decode(reader, reader.uint32());
            continue;
          }
          case 8: {
            if (tag !== 66) {
              break;
            }

            message.loginResponse = LoginResponse.decode(reader, reader.uint32());
            continue;
          }
          case 9: {
            if (tag !== 74) {
              break;
            }

            message.hash = Hash.decode(reader, reader.uint32());
            continue;
          }
          case 10: {
            if (tag !== 82) {
              break;
            }

            message.mouseEvent = MouseEvent.decode(reader, reader.uint32());
            continue;
          }
          case 11: {
            if (tag !== 90) {
              break;
            }

            message.audioFrame = AudioFrame.decode(reader, reader.uint32());
            continue;
          }
          case 12: {
            if (tag !== 98) {
              break;
            }

            message.cursorData = CursorData.decode(reader, reader.uint32());
            continue;
          }
          case 13: {
            if (tag !== 106) {
              break;
            }

            message.cursorPosition = CursorPosition.decode(reader, reader.uint32());
            continue;
          }
          case 14: {
            if (tag !== 112) {
              break;
            }

            message.cursorId = reader.uint64() as bigint;
            continue;
          }
          case 15: {
            if (tag !== 122) {
              break;
            }

            message.keyEvent = KeyEvent.decode(reader, reader.uint32());
            continue;
          }
          case 16: {
            if (tag !== 130) {
              break;
            }

            message.clipboard = Clipboard.decode(reader, reader.uint32());
            continue;
          }
          case 19: {
            if (tag !== 154) {
              break;
            }

            message.misc = Misc.decode(reader, reader.uint32());
            continue;
          }
          case 20: {
            if (tag !== 162) {
              break;
            }

            message.cliprdr = Cliprdr.decode(reader, reader.uint32());
            continue;
          }
          case 25: {
            if (tag !== 202) {
              break;
            }

            message.peerInfo = PeerInfo.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  create(base?: DeepPartial<Message>): Message {
    return Message.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Message>): Message {
    const message = createBaseMessage();
    message.signedId = (object.signedId !== undefined && object.signedId !== null)
      ? SignedId.fromPartial(object.signedId)
      : undefined;
    message.publicKey = (object.publicKey !== undefined && object.publicKey !== null)
      ? PublicKey.fromPartial(object.publicKey)
      : undefined;
    message.testDelay = (object.testDelay !== undefined && object.testDelay !== null)
      ? TestDelay.fromPartial(object.testDelay)
      : undefined;
    message.videoFrame = (object.videoFrame !== undefined && object.videoFrame !== null)
      ? VideoFrame.fromPartial(object.videoFrame)
      : undefined;
    message.loginRequest = (object.loginRequest !== undefined && object.loginRequest !== null)
      ? LoginRequest.fromPartial(object.loginRequest)
      : undefined;
    message.loginResponse = (object.loginResponse !== undefined && object.loginResponse !== null)
      ? LoginResponse.fromPartial(object.loginResponse)
      : undefined;
    message.hash = (object.hash !== undefined && object.hash !== null) ? Hash.fromPartial(object.hash) : undefined;
    message.mouseEvent = (object.mouseEvent !== undefined && object.mouseEvent !== null)
      ? MouseEvent.fromPartial(object.mouseEvent)
      : undefined;
    message.audioFrame = (object.audioFrame !== undefined && object.audioFrame !== null)
      ? AudioFrame.fromPartial(object.audioFrame)
      : undefined;
    message.cursorData = (object.cursorData !== undefined && object.cursorData !== null)
      ? CursorData.fromPartial(object.cursorData)
      : undefined;
    message.cursorPosition = (object.cursorPosition !== undefined && object.cursorPosition !== null)
      ? CursorPosition.fromPartial(object.cursorPosition)
      : undefined;
    message.cursorId = (object.cursorId !== undefined && object.cursorId !== null)
      ? BigInt(object.cursorId)
      : undefined;
    message.keyEvent = (object.keyEvent !== undefined && object.keyEvent !== null)
      ? KeyEvent.fromPartial(object.keyEvent)
      : undefined;
    message.clipboard = (object.clipboard !== undefined && object.clipboard !== null)
      ? Clipboard.fromPartial(object.clipboard)
      : undefined;
    message.misc = (object.misc !== undefined && object.misc !== null) ? Misc.fromPartial(object.misc) : undefined;
    message.cliprdr = (object.cliprdr !== undefined && object.cliprdr !== null)
      ? Cliprdr.fromPartial(object.cliprdr)
      : undefined;
    message.peerInfo = (object.peerInfo !== undefined && object.peerInfo !== null)
      ? PeerInfo.fromPartial(object.peerInfo)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | bigint | undefined;

export type DeepPartial<T> = T extends bigint ? string | number | bigint
  : T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
